// extracted by mini-css-extract-plugin
export default {"badge":"VUYiLj0EDlkRzO0MFkUg"};